import { ethers } from 'ethers';
import { getConnectedProvider, getConnectedProviderType } from '../../../lib/eth';
import { getChainConfiguration } from '../../../lib/chainConfiguration';
import { fetchManaBalance } from './fetchManaBalance';
export async function buildWallet(appChainId) {
    const provider = await getConnectedProvider();
    if (!provider) {
        // This could happen if metamask is not installed
        throw new Error('Could not connect to Ethereum');
    }
    const eth = new ethers.providers.Web3Provider(provider);
    const accounts = await eth.listAccounts();
    if (accounts.length === 0) {
        // This could happen if metamask was not enabled
        throw new Error('Could not get address');
    }
    const address = accounts[0].toString();
    const { chainId } = await eth.getNetwork();
    const chainConfig = getChainConfiguration(chainId);
    const appChainConfig = getChainConfiguration(appChainId);
    const networks = {};
    for (const network of Object.keys(appChainConfig.networkMapping)) {
        const networkChainId = appChainConfig.networkMapping[network];
        networks[network] = {
            chainId: networkChainId,
            mana: await fetchManaBalance(networkChainId, address)
        };
    }
    return {
        address: address.toLowerCase(),
        providerType: getConnectedProviderType(),
        networks: networks,
        network: chainConfig.network,
        chainId
    };
}
//# sourceMappingURL=buildWallet.js.map